<template>
  <div class="details reservationoverview">
    <div class="details__title px-5"></div>
    <h1 class="title is-3">
      {{ $t("ReservationForm.partialReservationErrorTitle") }}
    </h1>
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="partial-error-card">
            <!-- Header Section -->
            <div class="error-header has-text-centered">
              <div class="icon-container">
                <span class="icon is-large">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <h2 class="error-title">
                {{ $t("ReservationForm.partialReservationErrorTitle") }}
              </h2>
            </div>

            <!-- Content Sections -->
            <div class="error-content">
              <div class="info-section">
                <div class="section-icon">
                  <span class="icon">
                    <i class="fas fa-info-circle"></i>
                  </span>
                </div>
                <div class="section-content">
                  <h3 class="title is-2">
                    {{ $t("ReservationForm.whatHappened") }}
                  </h3>
                  <p class="section-text">
                    {{ $t("ReservationForm.partialErrorExplanation") }}
                  </p>
                </div>
              </div>

              <div class="info-section">
                <div class="section-icon">
                  <span class="icon">
                    <i class="fas fa-clock"></i>
                  </span>
                </div>
                <div class="section-content">
                  <h3 class="title is-2">
                    {{ $t("ReservationForm.nextSteps") }}
                  </h3>
                  <p class="section-text">
                    {{ $t("ReservationForm.nextStepsDescription") }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="error-actions has-text-centered">
              <div class="buttons is-centered">
                <button
                  class="c-button c-button--primary"
                  @click="goToLandingPage"
                >
                  <span class="icon">
                    <i class="fas fa-home"></i>
                  </span>
                  <span>{{ $t("ReservationForm.backToHome") }}</span>
                </button>
                <button class="button is-link" @click="goToReservationOverview">
                  <span class="icon">
                    <i class="fas fa-list"></i>
                  </span>
                  <span>{{ $t("ReservationForm.viewReservations") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHelper from "@/helpers/common.helper";

export default {
  name: "PartialErrorPage",
  data() {
    return {
      PAGES: CommonHelper.PAGES
    };
  },
  methods: {
    goToLandingPage() {
      this.$router.push({ name: this.PAGES.LandingPage });
    },
    goToReservationOverview() {
      this.$router.push({ name: this.PAGES.ReservationOverview });
    }
  }
};
</script>

<style scoped>
.partial-error-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e8e8e8;
}

.error-header {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  padding: 3rem 2rem 2rem;
  border-bottom: 1px solid #f1c40f;
}

.icon-container {
  margin-bottom: 1.5rem;
}

.icon-container .icon {
  color: #f39c12;
  font-size: 3.5rem;
}

.error-title {
  color: #2c3e50;
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  line-height: 1.3;
}

.error-subtitle {
  color: #7f8c8d;
  font-size: 1.1rem;
  line-height: 1.5;
  margin: 0;
}

.error-content {
  padding: 2.5rem 2rem;
}

.info-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid #3498db;
}

.info-section:last-child {
  margin-bottom: 0;
  border-left-color: #e67e22;
}

.section-icon {
  margin-right: 1rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}

.section-icon .icon {
  color: #3498db;
  font-size: 1.25rem;
}

.info-section:last-child .section-icon .icon {
  color: #e67e22;
}

.section-content {
  flex: 1;
}

.section-title {
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  line-height: 1.3;
}

.section-text {
  color: #5a6c7d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

.error-actions {
  background: #f8f9fa;
  padding: 2rem;
  border-top: 1px solid #e9ecef;
}

.button .icon {
  margin-right: 0.5rem;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .error-header {
    padding: 2rem 1.5rem 1.5rem;
  }

  .error-content {
    padding: 2rem 1.5rem;
  }

  .error-actions {
    padding: 1.5rem;
  }

  .info-section {
    flex-direction: column;
    text-align: center;
  }

  .section-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>
